module.exports = __webpack_public_path__ + "img/card-shadow.51df720e.png";